import type { FieldErrors, UseFormRegister } from 'react-hook-form';

import Input from '@/components/Input';
import type { AlterAuthFormData } from '@/models/login.model';

interface LoginEmailInputProps {
  register: UseFormRegister<AlterAuthFormData>;
  errors: FieldErrors<AlterAuthFormData>;
}

export const LoginEmailInput = ({ register, errors }: LoginEmailInputProps) => (
  <>
    <Input
      {...register('email', { required: true })}
      placeholder="Email Address"
      inputStyle="rounded"
      data-testid="emailInput"
      autoComplete="email"
    />
    {errors.email && errors.email.type === 'required' && (
      <div className="error" role="alert">
        Email Address is required
      </div>
    )}
  </>
);
